<template>
  <div class="drop-down">
    <div class="drop-down__head" @click="open = !open">
      <h5><slot name="header" /></h5>
      <DefPlus :result="open" />
    </div>

    <SlideUpDown :model-value="open">
      <div class="drop-down__block">
        <slot />
      </div>
    </SlideUpDown>
  </div>
</template>

<script>
import SlideUpDown from 'vue3-slide-up-down';
import DefPlus from '@components/Def/DefPlus/DefPlus.vue';

export default {
  name: 'DropDown',
  components: {
    DefPlus,
    SlideUpDown,
  },
  props: {
    active: Boolean,
  },
  data() {
    return {
      open: this.active ?? false,
    };
  },
};
</script>

<style lang="scss">
.drop-down {
  border-bottom: 1px solid #dfdfdf;
  &:first-child {
    border-top: 1px solid #dfdfdf;
  }
  &__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 64px;
    font-weight: 500;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #191918;
    &:hover {
      cursor: pointer;
    }
    h5 {
      font-size: rem(14);
      @include point-md {
        font-size: rem(16);
      }
    }
  }
  &__block {
    padding-bottom: 18px;
  }
}
</style>
